import { Link, useNavigate } from "react-router-dom";

import BackSvg from "../../../../public/assets/svg/breadcrumbs-back.svg";

import styles from "./Breadcrumbs.module.scss";

type Props = {
  breadcrumbs?: { value: string; href: string | null }[];
};

const Breadcrumbs = ({ breadcrumbs }: Props) => {
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <button onClick={() => navigate(-1)} className={styles.goBack}>
        <BackSvg opacity={0.7} className={styles.backSvg} />
      </button>
      {breadcrumbs && (
        <ul className={styles.breadcrumb_list}>
          {breadcrumbs.map((breadcrumb, index) => (
            <Link
              className={styles.link}
              key={index}
              to={breadcrumb?.href ? breadcrumb?.href : ""}
            >
              {breadcrumb.value}
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
};

export { Breadcrumbs };
